var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "19px",
    viewBox: "0 0 27 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon - Card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Backend---UIUX",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Orders-(Single-view)",
    transform: "translate(-545.000000, -750.000000)",
    fill: "#7C8999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(514.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-Method",
    transform: "translate(0.000000, 628.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon---Card",
    transform: "translate(31.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1553024,0 L2.84464483,0 C1.27601118,0 0,1.25666748 0,2.80152142 L0,16.1984786 C0,17.7433325 1.27601118,19 2.84464483,19 L24.1553552,19 C25.7239888,19 27,17.7433325 27,16.1984786 L27,2.80152142 C27,1.25666748 25.7239361,0 24.1553024,0 Z M2.84464483,0.933840473 L24.1553552,0.933840473 C25.201234,0.933840473 26.0517851,1.77170535 26.0517851,2.80152142 L26.0517851,3.10456125 L0.948214945,3.10456125 L0.948214945,2.80152142 C0.948214945,1.77170535 1.79876602,0.933840473 2.84464483,0.933840473 Z M24.1553024,18.0661595 L2.84464483,18.0661595 C1.79876602,18.0661595 0.948214945,17.2283466 0.948214945,16.1984786 L0.948214945,6.69258398 L26.0517323,6.69258398 L26.0517323,16.1984786 C26.0517323,17.2283466 25.2011812,18.0661595 24.1553024,18.0661595 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "2 10 19 10 19 11 2 11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "21 10 25 10 25 11 21 11"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.de390f8ec61588fe3a97451c3d425872.svg";
export { ForwardRef as ReactComponent };